module.exports = __webpack_public_path__ + "static/img/012.758202d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/fushen/012.png
// module id = 1yOe
// module chunks = 0